const MAP = {
  live: { label: "LIVE", cls: "text-emerald-500 bg-emerald-500/10 border-emerald-500/20", dot: "bg-emerald-500" },
  healthy: { label: "HEALTHY", cls: "text-emerald-500 bg-emerald-500/10 border-emerald-500/20", dot: "bg-emerald-500" },
  draft: { label: "DRAFT", cls: "text-violet-400 bg-violet-500/10 border-violet-500/20", dot: "bg-violet-400" },
  idle: { label: "IDLE", cls: "text-neutral-400 bg-neutral-500/10 border-neutral-500/20", dot: "bg-neutral-400" },
  warning: { label: "WARNING", cls: "text-amber-500 bg-amber-500/10 border-amber-500/20", dot: "bg-amber-500" },
  off_air: { label: "OFF AIR", cls: "text-red-500 bg-red-500/10 border-red-500/20", dot: "bg-red-500" },
};

export function StatusBadge({ status, testid }) {
  const s = MAP[status] || MAP.idle;
  const live = status === "live" || status === "healthy";
  return (
    <span data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm border text-[10px] font-bold tracking-wider font-mono ${s.cls}`}>
      <span className="relative flex h-1.5 w-1.5">
        {live && <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${s.dot}`} />}
        <span className={`relative inline-flex rounded-full h-1.5 w-1.5 ${s.dot}`} />
      </span>
      {s.label}
    </span>
  );
}
